import React from "react"
import ProgressSetup from "./ProgressSetup";
import SetupGuide from "./SetupGuide";
import { MdOutlineCheckCircle } from "react-icons/md";

const Finish = ({ step = 0, totalSteps = 4, finishSetup = () => { } }) => {
    const title = "Configurações Iniciais Concluídas!"
    const description = "Tudo pronto! A estrutura compartilhada da conta está configurada. Na próxima tela, você verá um guia individual com os processos essenciais da plataforma."
    const btnText = "Concluir configuração"

    return (
        <ProgressSetup
            step={step}
            totalSteps={totalSteps}
            title={title}
            description={description}
            btnText={btnText}
            onClick={finishSetup}
        >
            <SetupGuide
                icon={<MdOutlineCheckCircle />}
                title="Sua conta está pronta para começar"
                items={[
                    { title: "Estrutura criada", description: "Funil, etapas e padrões comerciais já estão disponíveis para a equipe." },
                    { title: "Tutorial na sequência", description: "Cada usuário verá instruções para cadastrar leads, criar tarefas e utilizar os canais disponíveis." },
                    { title: "Configuração flexível", description: "Tudo pode ser revisado depois nos menus de configurações e integrações." },
                ]}
            />
        </ProgressSetup>
    )
}

export default Finish
